import { type SellerPromotionV2 } from '@redteclab/api/clients/bully'
import { type FC } from 'react'

import GetSellerPromotionNotification from './GetSellerPromotionNotification'

export type SellerPromotionBannerProps = {
  sellerPromotion: SellerPromotionV2
  sellerName: string
  sellerId: string
}

export const SellerPromotionBanner: FC<SellerPromotionBannerProps> = ({
  sellerPromotion,
  sellerName,
  sellerId,
}) => {
  return (
    <div className="u-margin--bottom u-border o-Cart-ErxNotification--Border">
      <GetSellerPromotionNotification
        sellerPromotion={sellerPromotion}
        sellerName={sellerName}
        sellerId={sellerId}
      />
    </div>
  )
}
